/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RunPauseModal_run$ref: FragmentReference;
declare export opaque type RunPauseModal_run$fragmentType: RunPauseModal_run$ref;
export type RunPauseModal_run = {|
  +id: string,
  +machine: {|
    +id: string,
    +type: {|
      +id: string,
      +name: string,
    |},
  |},
  +$refType: RunPauseModal_run$ref,
|};
export type RunPauseModal_run$data = RunPauseModal_run;
export type RunPauseModal_run$key = {
  +$data?: RunPauseModal_run$data,
  +$fragmentRefs: RunPauseModal_run$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "RunPauseModal_run",
  "type": "Run",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "machine",
      "storageKey": null,
      "args": null,
      "concreteType": "Machine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "type",
          "storageKey": null,
          "args": null,
          "concreteType": "MachineType",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e6aa87e02e2e011dc596153c233cf0b1';
module.exports = node;
